import {
  Box,
  FormControl,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import { ListParams } from "models/common";
import React, { ChangeEvent } from "react";

export interface InputSearchProps {
  onSearchChange?: (newFilter: ListParams) => void;
  filter: ListParams;
  label: string;
}

const useStyles = makeStyles(() => ({
  input: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      borderRadius: 10,
      height: 42,
      paddingRight: 10,
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 12px",
      fontSize: "0.875rem",
      height: "100%",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      color: "#1E293B",
      "&::placeholder": {
        color: "#94A3B8",
        opacity: 1,
      },
    },
    "& .MuiInputAdornment-root": {
      marginLeft: 0,
      marginRight: 2,
    },
  },
}));

export default function InputSearch({ onSearchChange, filter, label }: InputSearchProps) {
  const classes = useStyles();
  const searchRef = React.useRef<HTMLInputElement>();

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!onSearchChange) return;
    const newFilter: ListParams = {
      ...filter,
      name: e.target.value,
      page: 0,
    };
    onSearchChange(newFilter);
  };

  return (
    <Box className={classes.input}>
      <FormControl fullWidth variant="outlined" size="small">
        <TextField
          autoComplete="off"
          id="searchByName"
          placeholder={label}
          variant="outlined"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search style={{ color: "#64748B", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
          defaultValue={filter.search || filter.name}
          onChange={handleSearchChange}
          inputRef={searchRef}
          type="search"
        />
      </FormControl>
    </Box>
  );
}
